/** Stamp `#t=start,end` so Remotion's HTML5 Video does not overwrite it.

 *  Legacy `<Video startFrom endAt>` appends `#t` from
 *  min(innerSequenceDuration, compositionDuration) / fps. Concatenated clip
 *  compositions are the sum of cuts, so that end timestamp is too early
 *  (and later cuts can get end < start). A pre-existing hash is left as-is.
 */
export function withHtml5VideoFragment(
  src: string,
  trimBefore: number,
  trimAfter: number,
  fps: number,
): string {
  const toSeconds = (frames: number): number => Math.round((frames / fps) * 100) / 100;
  const hashIndex = src.indexOf('#');
  const base = hashIndex === -1 ? src : src.slice(0, hashIndex);
  return `${base}#t=${toSeconds(trimBefore)},${toSeconds(trimAfter)}`;
}
